import React from 'react'
import Experience from './Experience.jsx'

import EXPERIENCE_CAOS_IMAGE_PATH from 'images/experience_caos.jpg'
import EXPERIENCE_CAOS_SONG_PATH from 'audio/6. CONVERSACION MB.mp3'

const CaosText = () => (
	<span className="text-center">
		<p>Profundizar.</p>
		<p>Profundizar en la tormenta.</p>
		<p>El el caos.</p>
		<p>Y aprender.</p>
		<p>La templanza como eje para atravesarlo.</p>
		<p>El ojo de la tormenta guarda información.</p>
		<p>Para llegar a él debes dejarte arrasar.</p>
		<p>La tormenta es tu mente, el ojo la claridad.</p>
		<p>¿Cuánta claridad podes ganar con cada ciclo?</p>
		<p>¿Cuánta templanza podes probarte?</p>
		<p>Cuánta aceptación</p>

		<p>Y sin el telón de bruma</p>
		<p>¿Cuál es tu deseo?</p>
	</span>
)

const ExperienceCaos = (props) => {
	return (<Experience
		image={EXPERIENCE_CAOS_IMAGE_PATH}
		title={"Caos"}
		phrase={"¿Sos capaz de soltar el control y danzar con la tormenta, hasta encontrar en su centro el deseo que olvidaste nombrar?"}
		phrase_rect={{ top: 60, left: 71, width: 25, height: 20 }}
		text={<CaosText />}
		text_rect={{ top: 50, left: 17, width: 32, height: 85 }}
		text_interaction_zone_rect={{ top: 41.5, left: 10, width: 7, height: 14 }}		
		song={EXPERIENCE_CAOS_SONG_PATH}
		song_rect={{ top: 9, left: 48, width: 7, height: 13 }}
		{...props}
	/>)			
}

export default ExperienceCaos